import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as ReactJsxRuntime from 'react/jsx-runtime'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '../ultron-turing-manager/src/index.css'
import App from './App'
import { syncAppSuiteClientIdFromRuntime } from './services/appsuiteApi'

// Expose React globals for dynamically loaded template bundles.
// Template bundles are built with React externalized — they reference these at runtime.
Object.assign(window, {
  React,
  ReactDOM,
  ReactJsxRuntime,
  __APPSUITE_SHELL__: true,
})
syncAppSuiteClientIdFromRuntime()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
